import React, { FC } from 'react'

import CustomFormCommonEntitySelectionDrawerManagerContent from './Content'
import CustomFormCommonEntityPropsManagerProvider from './contexts/CustomFormCommonEntityPropsManager/Provider'
import { CustomFormQuestion } from 'components/tools/CustomForm/types'

export type CustomFormCommonEntitiesProps = {
  defaultView?: 'SEARCH_ENTITY' | 'SELECT_ENTITY'
  questionKey: string
  currentEntity: {
    label: string
    labelPlural: string
    key: string
    keyPlural: string
  }
}

type Props = CustomFormCommonEntitiesProps & {
  question: CustomFormQuestion
  disabled?: boolean
}

const CustomFormCommonEntitySelectionDrawer: FC<Props> = ({ question, disabled, ...props }) => {
  return (
    <CustomFormCommonEntityPropsManagerProvider {...props}>
      <CustomFormCommonEntitySelectionDrawerManagerContent question={question} disabled={disabled} />
    </CustomFormCommonEntityPropsManagerProvider>
  )
}

export default CustomFormCommonEntitySelectionDrawer
